module.exports = __webpack_public_path__ + "50949180007f281e7f17e79f7c3ec181.svg";